import { render } from "./policyCenter.vue?vue&type=template&id=48e013d8&scoped=true"
import script from "./policyCenter.vue?vue&type=script&lang=js"
export * from "./policyCenter.vue?vue&type=script&lang=js"

import "./policyCenter.vue?vue&type=style&index=0&id=48e013d8&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e013d8"]])

export default __exports__